import React from 'react';
import { graphql, Link as GatsbyLink } from 'gatsby';
import styled, { css } from 'styled-components';
import { buildUrl } from '../../utils';

const commonLinkStyles = () => {
  return css`
    display: inline-block;
  `;
};

const StyledLinkInternal = styled(GatsbyLink)`
  ${commonLinkStyles()};
`;

const StyledLinkExternal = styled.a`
  ${commonLinkStyles()};
`;

export const Link = ({ to, children, ...props }) => {
  const isExternal = to.url;
  const LinkComponent = isExternal ? StyledLinkExternal : StyledLinkInternal;
  const slug = typeof to === 'string' ? to : to && to.slug;

  return (
    <LinkComponent
      {...(isExternal
        ? {
            href: to.url,
            target: '_blank',
            rel: 'noopener',
          }
        : {
            to: slug === '/' ? slug : buildUrl(slug, to),
          })}
      {...props}
    >
      {children}
    </LinkComponent>
  );
};

export const LinkFragment = graphql`
  fragment LinkFragment on Node {
    ... on DatoCmsHome {
      slug
    }
    ... on DatoCmsPage {
      slug
      treeParent {
        slug
        treeParent {
          slug
          treeParent {
            slug
          }
        }
      }
    }
    ... on DatoCmsService {
      slug
    }
    ... on DatoCmsPlatform {
      slug
    }
    ... on DatoCmsIndustry {
      slug
    }
    ... on DatoCmsResourceListing {
      slug
    }
    ... on DatoCmsEbookListing {
      slug
    }
    ... on DatoCmsBlogListing {
      slug
    }
    ... on DatoCmsBlogCategory {
      slug
      internal {
        type
      }
    }
    ... on DatoCmsBlog {
      slug
      categories {
        slug
      }
      internal {
        type
      }
    }
    ... on DatoCmsBlogAuthor {
      slug
      internal {
        type
      }
    }
    ... on DatoCmsCaseStudyListing {
      slug
    }
    ... on DatoCmsCaseStudy {
      slug
      internal {
        type
      }
    }
    ... on DatoCmsToolListing {
      slug
    }
    ... on DatoCmsWebinarListing {
      slug
    }
    ... on DatoCmsSalesforceExplainerListing {
      slug
    }
    ... on DatoCmsSalesforceExplainer {
      slug
      internal {
        type
      }
    }
    ... on DatoCmsContact {
      slug
    }
    ... on DatoCmsCallback {
      slug
    }
    ... on DatoCmsExternalUrl {
      url
    }
  }
`;
